import type { Item } from 'core/domains/cart';

export enum DELETE_ITEM_CONST {
  TEST_ID = 'delete-item',
}

type Product = Pick<Item, 'image' | 'name'>;

export type DeleteItemProps = {
  onDelete: () => void;
  onClose: () => void;
  product: Product;
  visible: boolean;
};
